"use client";

import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useTranslation } from "@/hooks/localization/useTranslations";
import SvgPcHeart from "./SvgPcHeart";

interface Props {
  showLabel?: boolean;
}

const FavoritesButton: React.FC<Props> = ({ showLabel = true }) => {
  const router = useRouter();
  const t = useTranslation();

  return (
    <div
      className="pc-favorites-btn"
      onClick={() => router.push(PagesPaths.favorites)}
      aria-label={t.favorites}
    >
      <SvgPcHeart />
      {showLabel && (
        <span className="hide-to-vistor" style={{ marginInlineStart: 8 }}>
          {t.favorites}
        </span>
      )}
    </div>
  );
};

export default FavoritesButton;
